import { defineMessages } from 'react-intl';

export const messages: {
	menuTriggerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideMenuItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	menuTriggerLabel: {
		id: 'search-page.app-filter-sidebar.filter-menu.trigger',
		defaultMessage: 'Show more options',
		description: 'Label for the button that opens the filter menu',
	},
	hideMenuItemLabel: {
		id: 'search-page.app-filter-sidebar.filter-menu.menu-item.hide',
		defaultMessage: 'Hide app',
		description: 'Label for the menu item that hides the app when clicked',
	},
});
